module.exports = __webpack_public_path__ + "img/20190712165045YY截图20190711014525.550bebfd.png";